import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_post = _resolveComponent("post")!
  const _component_posts = _resolveComponent("posts")!
  const _component_remaining_height = _resolveComponent("remaining-height")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar_title, { class: "text-center" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.heading) + " (" + _toDisplayString(_ctx.total) + ") ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "bg-grey-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_remaining_height, {
            class: "custom-scrollbar custom-scrollbar--lg",
            disable: _ctx.$q.screen.lt.lg
          }, {
            default: _withCtx(() => [
              _createVNode(_component_posts, {
                filters: _ctx.filters,
                persist: "",
                "infinite-scroll": "",
                "scroll-target": ".custom-scrollbar",
                onTotal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.total = $event))
              }, {
                default: _withCtx(({ visiblePosts }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePosts, (post) => {
                    return (_openBlock(), _createBlock(_component_post, {
                      key: post.id,
                      post: post,
                      notes: "",
                      trash: "",
                      actions: "",
                      popup: "",
                      class: "q-my-md"
                    }, null, 8, ["post"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["filters"])
            ]),
            _: 1
          }, 8, ["disable"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}